import {
  Column,
  ColumnChooser,
  ColumnDirective,
  ColumnMenu,
  ColumnsDirective,
  Edit,
  EditSettingsModel,
  ExcelExport,
  Filter,
  FilterSettingsModel,
  GridComponent,
  Group,
  Inject,
  Page,
  PageSettingsModel,
  Resize,
  Toolbar,
} from '@syncfusion/ej2-react-grids';
import React, { Component } from 'react';
import Message from '../../../../utils/Message/Message';
import { GetBackendUrlForGlobalFunctions } from '../../../../App';
import defaultImage from '../../../../assets/images/DefaultImage.png';
import { all_information, loadingShow } from '../../../../App';
import './style.css';
import {
  AddEventResources,
  DeleteEventResources,
  EditEventResources,
  getEventResources,
} from '../../../../services/EventResources/EventResources';

interface IState {
  EventResourcesData: any;
}
interface IProps {}

export class EventResources extends Component<IProps, IState> {
  private gridEventResourcesObj: any;
  private imageArray = [
    'real_00001.jpg',
    'real_00002.jpg',
    'real_00005.jpg',
    'real_00006.jpg',
  ];
  constructor(prop: IProps) {
    super(prop);
    this.state = {
      EventResourcesData: [],
    };
  }
  public FilterOptions: FilterSettingsModel = { type: 'Menu' };
  public validationRule: Object = { required: true };
  public toolbarOptions = [
    'Add',
    'Edit',
    'Delete',
    'Update',
    'Cancel',
    {
      text: 'Refresh',
      tooltipText: 'Refresh',
      prefixIcon: 'e-refresh',
      id: 'refresh',
    },
    'ColumnChooser',
    'ExcelExport',
    'Search',
  ];
  public editOptions: EditSettingsModel = {
    allowAdding: true,
    allowDeleting: true,
    allowEditing: true,
  };
  public pageOptions: PageSettingsModel = {
    currentPage: 1,
    pageSize: 12,
    pageCount: 8,
    pageSizes: true,
  };
  toolbarClick(args: any) {
    if (args.item.id === 'refresh') {
      this.getEventResources();
    }
    if (
      this.gridEventResourcesObj &&
      args.item.id === 'gridEventResources_excelexport'
    ) {
      this.gridEventResourcesObj.excelExport();
    }
  }
  getEventResources() {
    getEventResources().then((res) => {
      this.setState({ EventResourcesData: res.data });
    });
  }
  componentDidMount() {
    this.getEventResources();
  }
  SavePointAdd(data: any) {
    const obj = {
      organizationId: all_information.company_id?.toString(),
      createdBy: all_information.user_id,
      firstName: data.firstName,
      middleName: data.middleName,
      lastName: data.lastName,
      type: data.type,
      contactNumber: data.contactNumber,
      imageUrl: this.random_item(this.imageArray),
    };
    AddEventResources(obj)
      .then((res: any) => {
        Message.success('Success');
        loadingShow(false);
        this.getEventResources();
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  }
  savePointEdit(data: any) {
    const obj = {
      organizationId: all_information.company_id?.toString(),
      createdBy: all_information.user_id,
      firstName: data.firstName,
      middleName: data.middleName,
      lastName: data.lastName,
      type: data.type,
      contactNumber: data.contactNumber,
      imageUrl: this.random_item(this.imageArray),
      id: data.id,
    };
    //(obj);

    EditEventResources(obj)
      .then((res: any) => {
        Message.success('Success');
        loadingShow(false);
        this.getEventResources();
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  }
  savePointDelete(obje: any) {
    const obj = JSON.stringify({
      id: obje[0].id,
    });
    //(obj);

    DeleteEventResources(obj)
      .then((res: any) => {
        Message.success('Success');
        loadingShow(false);
        this.getEventResources();
      })
      .catch((err: any) => {
        if (err.response) {
          Message.error(
            err.response.data +
              '\n' +
              err.response.status +
              '\n' +
              err.response.headers
          );
        } else if (err.request) {
          Message.error(err.request);
        } else {
          Message.error('Error: ' + err.message);
        }
        loadingShow(false);
      });
  }
  random_item(items: any) {
    return items[Math.floor(Math.random() * items.length)];
  }
  ImageTemplateResources(args: any) {
    var imageUrl =
      GetBackendUrlForGlobalFunctions() +
      'static/media/people/' +
      args.imageUrl;
    return (
      <div className='event-resources-image'>
        <img src={defaultImage} alt='Person' />
      </div>
    );
  }
  actionBeginEventResources(args: any) {
    if (args.action === 'add') {
      this.SavePointAdd(args.data);
    } else if (args.action === 'edit') {
      this.savePointEdit(args.data);
    } else if (args.requestType === 'delete') {
      this.savePointDelete(args.data);
    }
  }
  render() {
    return (
      <div>
        <GridComponent
          id='gridEventResources'
          editSettings={this.editOptions}
          toolbar={this.toolbarOptions}
          dataSource={this.state.EventResourcesData}
          height='calc(-220px + 100vh)'
          ref={(g) => (this.gridEventResourcesObj = g)}
          filterSettings={this.FilterOptions}
          allowFiltering={true}
          allowPaging={true}
          pageSettings={this.pageOptions}
          showColumnMenu={true}
          allowResizing={true}
          allowGrouping={true}
          allowExcelExport={true}
          showColumnChooser
          toolbarClick={this.toolbarClick.bind(this)}
          actionBegin={this.actionBeginEventResources.bind(this)}
          gridLines='Both'
        >
          <ColumnsDirective>
            <ColumnDirective
              field='imageUrl'
              headerText='#'
              textAlign='Left'
              maxWidth={70}
              isPrimaryKey
              template={this.ImageTemplateResources.bind(this)}
            />
            <ColumnDirective
              field='firstName'
              headerText='First Name'
              textAlign='Left'
              validationRules={this.validationRule}
            />
            <ColumnDirective
              field='middleName'
              headerText='Middle Name'
              textAlign='Left'
            />
            <ColumnDirective
              field='lastName'
              headerText='Last Name'
              textAlign='Left'
              validationRules={this.validationRule}
            />
            <ColumnDirective
              field='contactNumber'
              headerText='Contact Number'
              textAlign='Left'
              validationRules={this.validationRule}
            />
            <ColumnDirective
              field='type'
              headerText='Type'
              textAlign='Left'
              validationRules={this.validationRule}
            />
          </ColumnsDirective>
          <Inject
            services={[
              Edit,
              Toolbar,
              Filter,
              Page,
              ColumnChooser,
              ExcelExport,
              ColumnMenu,
              Group,
              Resize,
            ]}
          />
        </GridComponent>
      </div>
    );
  }
}

export default EventResources;
